import { TextInput, required } from "react-admin";

import CurrencyInput from "../common/CurrencyInput";
import FormContainer from "../common/FormContainer";
import ServiceResourcesInput from "./ServiceResourcesInput";

const ServiceTemplateFields = () => {
  return (
    <>
      <FormContainer>
        <TextInput source="name" validate={required()} fullWidth />
      </FormContainer>

      <FormContainer maxWidth="xl">
        <TextInput
          source="invoiceLineText"
          multiline
          defaultValue=""
          parse={(v: any) => String(v)}
          helperText="wird als Alternative zum Namen in einer Rechnung verwendet (Titel + Leerzeile + optionale Beschreibung)"
          fullWidth
        />
      </FormContainer>

      <FormContainer maxWidth="sm">
        <CurrencyInput source="monthlyCost" validate={required()} fullWidth />
      </FormContainer>

      <FormContainer>
        <ServiceResourcesInput />
      </FormContainer>
    </>
  );
};

export default ServiceTemplateFields;
